import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankService } from '@manager-app/storage/service/bank.service';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgIf } from '@angular/common';

/**
 * Create and edit banks
 *
 * @export
 * @class BankNewComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-bank-new',
    templateUrl: './bank-new.component.html',
    imports: [NgIf, FormsModule, ReactiveFormsModule, TranslocoPipe]
})
export class BankNewComponent implements OnInit {
  @ViewChild('templateRef') templateRef: TemplateRef<any>;
  @Output() update = new EventEmitter<any>();
  private _id;
  @Input()
  set id(id) {
    this._id = id || null;
    if (id) {
      this.getItem();
    }
  }
  get id() {
    return this._id;
  }
  bankForm: UntypedFormGroup;
  isLoading = {
    form: false
  };
  isEdit = false;

  constructor(
    private modal: NgbModal,
    private fb: UntypedFormBuilder,
    private api: BankService,
    private toastr: HcToastrService,
    private errorHandlerService: ErrorHandlerService,
    private tr: TranslocoService
  ) { }

  ngOnInit() {
    this.createForm();
  }

  private async getItem() {
    this.isLoading.form = true;
    setTimeout(() => {
      this.addItem();
    }, 0);
    try {
      const result = await this.api.getBank(this.id);
      if (result) {
        this.updateForm(result);
      }
    } catch (err) {
      this.toastr.error(this.tr.translate('bank-new.ts.error'));
    } finally {
      this.isLoading.form = false;
    }
  }

  private updateForm(item) {
    this.isEdit = true;
    this.bankForm.patchValue(item);
  }

  private createForm(): void {
    this.bankForm = this.fb.group({
      name: [''],
      address: [''],
      oldBic: [''],
      bic: [''],
    });
  }

  private addItem() {
    const userModal = this.modal.open(this.templateRef, { size: 'lg' });

    userModal.result.then(
      result => {
        this.closeModal(result);
      }
    ).catch(
      err => {
        this.closeModal(err);
      }
    );
  }

  showModal() {
    this.isEdit = false;
    this.addItem();
  }

  closeModal(modal) {
    this.update.emit(false);
    this.bankForm.reset();

    if (modal) {
      modal.dismiss();
    }
  }

  async onSubmitForm(modal) {
    const obj = this.bankForm.getRawValue();
    try {
      if (this.id) {
        await this.api.updateBank(this.id, obj);
        this.toastr.success(this.tr.translate('bank-new.ts.bankUpDate'));
      } else {
        await this.api.createBank(obj);
        this.toastr.success(this.tr.translate('bank-new.ts.bankCreate'));
      }
      this.update.emit(true);
      modal.dismiss();
    } catch (err: any) {
      this.errorHandlerService.check(err?.error);
    }
  }
}
